export default __webpack_public_path__ + "static/media/partnerImg.1f254d2e.png";